import { GetSpaceBase } from '../../types/GetSpaceBase';
import { getUndefinedSpace } from '../../utils/getUndefinedSpace';
import { spaceFactory } from '../../utils/spaceFactory';

export const getSpaceJCAP: GetSpaceBase = (group, space, context) => {
  const { negBooleans } = context;
  const {
    isJcap,
    isTotalPayment,
  } = negBooleans!;

  switch (group) {
    case 'NEG_OPTION': {
      switch (space) {
        case 'title': {
          if (isJcap && isTotalPayment) {
            return spaceFactory('NEG_OPTION.title.totalPayment').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_OPTION_SUMMARY': {
      switch (space) {
        case 'description': {
          if (isJcap && isTotalPayment) {
            return spaceFactory('NEG_OPTION_SUMMARY.description.totalPayment').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    default: break;
  }

  return getUndefinedSpace();
};
